export default {
	namespaced: true,
	state: {
		mini: false
	},
	getters: {
		type(state) {
			return state.mini
		}
	},
	mutations: {
		typyMutate(state, payload) {
			state.mini = payload.type
		}
	},
	actions: {
		update(context, payload) {
			context.commit('typyMutate', payload)
		}
	}
}